import { NgModule } from '@angular/core';
import {CbjMenuComponent} from './cbj-menu.component';
import {CommonModule} from '@angular/common';
import { CbjRippleModule } from '../ripple/index';
import { CbjButtonModule } from '../buttons/index';
export class CbjMenuModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    CbjButtonModule,
    CbjRippleModule
  ],
  declarations: [
    CbjMenuComponent
  ],
  exports: [
    CbjMenuComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjMenuModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
